var render, staticRenderFns
import script from "./v-countdown.vue?vue&type=script&lang=js&"
export * from "./v-countdown.vue?vue&type=script&lang=js&"
import style0 from "./v-countdown.vue?vue&type=style&index=0&id=24eb2067&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports